import { render, staticRenderFns } from "./COM_Footer_Setting.vue?vue&type=template&id=5460883a&"
import script from "./COM_Footer_Setting.vue?vue&type=script&lang=js&"
export * from "./COM_Footer_Setting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\UBoss\\Source\\Frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5460883a')) {
      api.createRecord('5460883a', component.options)
    } else {
      api.reload('5460883a', component.options)
    }
    module.hot.accept("./COM_Footer_Setting.vue?vue&type=template&id=5460883a&", function () {
      api.rerender('5460883a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/featureOnePage/ubossOnePage/COM_Footer_Setting.vue"
export default component.exports